<template>
  <div id="app">
    <!-- <datav /> -->
    <router-view class="view-router"></router-view>
  </div>
</template>

<script>
import datav from "./components/datav/index.vue";

export default {
  name: "app",
  components: {
    datav,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
body {
  background-image: url("http://screen.njrentong.com/BG.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  // overflow: hidden;
}
</style>
